import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadEmployerAllowancesByBusinessId } from 'store/employerAllowances/thunks/loadEmployerAllowancesByBusinessId.thunk';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { loadResourcesAndResourceEmployersOfProject } from 'store/resources/thunks/loadResourcesAndResourceEmployersOfProject';

export const openCreateAbsenceDialog = createAsyncThunk(
  'records/openCreateAbsenceDialog',
  async (projectId, { getState, dispatch }) => {
    const state = getState();

    const selectedProjectId = projectId
      ? projectId
      : selectSelectedProjectId(state);

    dispatch(loadEmployerAllowancesByBusinessId());

    dispatch(loadResourcesAndResourceEmployersOfProject(selectedProjectId));

    return;
  }
);
